<div [class.warning]="showWarning">
  <span *ngIf="displayValues.hours">{{ displayValues.hours }}&nbsp;:&nbsp;</span>
  <span *ngIf="displayValues.minutes">{{ displayValues.minutes }}&nbsp;:&nbsp;</span>
  <span *ngIf="displayValues.seconds">{{ displayValues.seconds }}</span>
</div>